import { hasPermission, PERMISSIONS, type Permission } from '@repo/contracts';

import { APP_ROUTES } from '@/constants/app-routes';

/**
 * The first screen the caller can open. Every route guard turns a caller away
 * to the home route, so home must never be a screen the caller is refused.
 */
export const homeRouteFor = (permissions: readonly Permission[]): string => {
  if (hasPermission(permissions, [PERMISSIONS.userRead])) return APP_ROUTES.people;
  if (hasPermission(permissions, [PERMISSIONS.roleRead])) return APP_ROUTES.applications;

  return APP_ROUTES.home;
};
